import React, { useState } from "react";
import "./RegisterForm.css";
const testPassword = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
const testEmail =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
function RegisterForm() {
  const [userName, setUserName] = useState();
  const [password, setPassword] = useState();
  const [email, setEmail] = useState();

  const [confirmPassword, setConfirmPassword] = useState();

  //current UserName
  function userNameHandler(e) {
    setUserName(e.target.value);
  }
  //current Password
  function passwordHandler(e) {
    setPassword(e.target.value);
  }
  //current Email
  function emailHandler(e) {
    setEmail(e.target.value);
  }

  //confirm password
  function confirmPasswordHandler(e) {
    setConfirmPassword(e.target.value);
  }
  // submit function
  function submitHandler(e) {
    if (!testPassword.test(password)) {
      alert(
        "Password should contain 8 letter use at least a symbol, upper and lower case letters and a number"
      );
      return;
    }

    if (!testEmail.test(email)) {
      alert("Please enter valid email adress");
      return;
    }
    if (localStorage.getItem(email) !== null) {
      alert("This email is already exists!!!");
      return;
    }

    if (confirmPassword !== password) {
      alert("Please confirm password correctly");
      return;
    }

    localStorage.setItem(
      email,
      JSON.stringify({ email: email, password: password, userName: userName })
    );
    alert("You have registered successfully please login");
  }

  return (
    <form className="registerForm-outer-div" onSubmit={submitHandler}>
      <p className="register-free">Register Free:</p>
      <div className="userName-outer-div">
        <label htmlFor="userName">FirstName:</label>
        <input
          id="userName"
          type="text"
          onChange={userNameHandler}
          required
        ></input>
      </div>

      <div className="lastName-outer-div">
        <label htmlFor="lastName">LastName:</label>
        <input type="text" id="lastName" required></input>
      </div>

      <div className="registerForm-email-outer-div">
        <label htmlFor="registerForm-email">Email:</label>
        <input
          id="registerForm-email"
          type="email"
          onChange={emailHandler}
          required
        ></input>
      </div>

      <div className="registerForm-password-outer-div">
        <label className="registerForm-password">Password:</label>
        <input
          className="registerForm-password"
          onChange={passwordHandler}
          type="password"
          required
        ></input>
      </div>

      <div className="registerForm-confirm-password-outer-div">
        <label htmlFor="registerForm-confirm-password">Confirm Password:</label>
        <input
          className="registerForm-confirm-password"
          onChange={confirmPasswordHandler}
          type="password"
          required
        ></input>
      </div>

      <button className="registerForm-submit-button">Submit</button>
    </form>
  );
}

export default RegisterForm;
